import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Switch, Button, message, Space, Divider } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { superCompanyApi } from '../../services/api';

const SuperCompanyForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      fetchDetail();
    }
  }, [id]);

  const fetchDetail = async () => {
    try {
      const res = await superCompanyApi.detail(id);
      if (res.success) {
        form.setFieldsValue(res.data);
      }
    } catch {
      // handled by interceptor
    }
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = isEdit
        ? await superCompanyApi.update(id, values)
        : await superCompanyApi.create(values);
      if (res.success) {
        message.success(isEdit ? '更新成功' : '创建成功');
        navigate('/super/companies');
      }
    } catch {
      // handled by interceptor
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <div style={{ marginBottom: 16, display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/super/companies')}>返回</Button>
        <h2 style={{ margin: 0 }}>{isEdit ? '编辑公司' : '添加公司'}</h2>
      </div>

      <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ maxWidth: 600 }}>
        <Form.Item name="name" label="公司名称" rules={[{ required: true, message: '请输入公司名称' }]}>
          <Input placeholder="请输入公司名称" />
        </Form.Item>

        <Form.Item name="slug" label="URL标识" rules={[
          { required: true, message: '请输入URL标识' },
          { pattern: /^[a-zA-Z0-9_-]+$/, message: '只允许字母、数字、下划线和横杠' }
        ]}>
          <Input placeholder="如: hetian, company-a" disabled={isEdit} />
        </Form.Item>

        <Form.Item name="logo_url" label="公司Logo URL">
          <Input placeholder="公司Logo图片URL" />
        </Form.Item>

        <Form.Item name="contact_name" label="联系人">
          <Input placeholder="联系人姓名" />
        </Form.Item>

        <Form.Item name="contact_phone" label="联系电话">
          <Input placeholder="联系电话" />
        </Form.Item>

        {isEdit && (
          <Form.Item name="is_active" label="启用状态" valuePropName="checked">
            <Switch checkedChildren="启用" unCheckedChildren="禁用" />
          </Form.Item>
        )}

        {!isEdit && (
          <>
            <Divider>管理员账户（可选，创建公司时同时创建管理员）</Divider>
            <Form.Item name="admin_username" label="管理员用户名">
              <Input placeholder="管理员登录用户名" />
            </Form.Item>
            <Form.Item name="admin_password" label="管理员密码">
              <Input.Password placeholder="管理员登录密码" />
            </Form.Item>
            <Form.Item name="admin_nickname" label="管理员昵称">
              <Input placeholder="管理员昵称" />
            </Form.Item>
          </>
        )}

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEdit ? '保存修改' : '创建公司'}
            </Button>
            <Button onClick={() => navigate('/super/companies')}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SuperCompanyForm;
